/**
 * RESPONSIBILITY: draw the way through to an event's video.
 *
 * A link over a still, and not an <iframe>. Embedding a player loads a third party's
 * script on a page a visitor did not ask to be watched on, and this site does not host
 * video — so the honest thing is a picture that says where the video is.
 */
import { THEME } from '@app/sections';
import { Band } from './Band';
import { Picture } from '../../commons/Picture';
import type { BandProps } from './kind';

export function Video({ s }: BandProps) {
  if (!s.videoHref) return null;

  return (
    <Band theme={THEME.Video} heading={s.heading}>
      <a className="ev-video" href={s.videoHref}>
        <Picture value={s.image} alt={s.heading || 'Watch'} className="ev-still" />
        <span className="ev-play" aria-hidden="true">▶</span>
        <span className="sr-only">Watch: {s.heading || 'video'}</span>
      </a>
    </Band>
  );
}
